import axios from "axios";

// const API_BASE_URL = "https://api.smts.org.in"; // change only here if needed
const API_BASE_URL = "https://demo.smts.org.in/api/";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
});

// Attach token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: Global API error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // If token expires → force logout
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("auth_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
